import React from 'react';
import PropTypes from 'prop-types';

import { ErrorMessage } from 'formik';
import {
  setLocalStorageOnFieldChange,
  getSavedValue,
} from './handleLocalStorageValues';

const NumberField = props => {
  const { formikProps, field, renderRequiredIcon } = props;
  const {
    values,
    handleChange,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
  } = formikProps;
  const { name, required, caption, placeholder, unit } = field;
  // const inputValue = getSavedValue(values, name, setFieldValue);
  return (
    <div className="form__field number d-flex flex-column align-items-center justify-content-center">
      {caption !== '' ? (
        <label htmlFor="name" className="field-label text-center">
          {caption}
          {required && renderRequiredIcon()}
        </label>
      ) : null}
      <div className="d-flex justify-content-center align-items-center">
        <input
          type="number"
          name={name}
          placeholder={placeholder}
          className="form-control col-sm-6 text-center mr-4"
          value={values[name]}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        <span className="unit-text">{unit}</span>
      </div>
      <ErrorMessage
        render={msg => <div className="validateError">{msg}</div>}
        name={name}
      />
    </div>
  );
};

NumberField.propTypes = {
  formikProps: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  renderRequiredIcon: PropTypes.func.isRequired,
};

export default NumberField;
